const scrollTo = (e, href) => { e.preventDefault(); document.querySelector(href)?.scrollIntoView({ behavior: "smooth" }); };

const linkStyle = { color: 'rgba(255,255,255,0.5)' };
const hoverTeal = (e) => e.target.style.color = '#00A8B3';
const hoverReset = (e) => e.target.style.color = 'rgba(255,255,255,0.5)';

export const Footer = () => (
  <footer className="py-12" style={{ background: '#1A1F36' }} data-testid="footer">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-2.5 mb-3">
            <div className="w-8 h-8 rounded-lg logo-teal flex items-center justify-center">
              <span className="font-heading text-sm font-bold text-white">C</span>
            </div>
            <span className="font-heading text-sm font-semibold text-white">CareContext&nbsp;Systems</span>
          </div>
          <p className="text-xs leading-relaxed max-w-xs mb-4" style={{ color: 'rgba(255,255,255,0.5)' }}>
            Patient owned healthcare infrastructure. Instant context for doctors, safe workflows for hospitals.
          </p>
          {/* Social Icons */}
          <div className="flex gap-3">
            {[
              { icon: "fa-brands fa-linkedin", href: "https://linkedin.com" },
              { icon: "fa-brands fa-twitter", href: "https://twitter.com" },
              { icon: "fa-brands fa-github", href: "https://github.com" },
            ].map(s => (
              <a key={s.icon} href={s.href} target="_blank" rel="noopener noreferrer"
                className="w-8 h-8 rounded-lg flex items-center justify-center transition-all hover:scale-110"
                style={{ background: 'rgba(255,255,255,0.08)' }}
                onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(0,168,179,0.2)'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.08)'}>
                <i className={`${s.icon} text-xs`} style={{ color: 'rgba(255,255,255,0.6)' }} />
              </a>
            ))}
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-xs font-heading font-semibold text-white mb-3">Quick Links</h4>
          <nav className="flex flex-col gap-1.5">
            {[{l:"Home",h:"#home"},{l:"Challenge",h:"#challenge"},{l:"Architecture",h:"#architecture"},{l:"Capabilities",h:"#capabilities"},{l:"Safety",h:"#safety"},{l:"Demo",h:"#demo"}].map(x=>(
              <a key={x.h} href={x.h} onClick={(e)=>scrollTo(e,x.h)} className="text-xs transition-colors"
                style={linkStyle} onMouseEnter={hoverTeal} onMouseLeave={hoverReset}>{x.l}</a>
            ))}
          </nav>
        </div>

        {/* Legal */}
        <div>
          <h4 className="text-xs font-heading font-semibold text-white mb-3">Legal</h4>
          <nav className="flex flex-col gap-1.5">
            {["Privacy Policy", "Terms of Service", "DPDP Compliance", "Data Security"].map(l => (
              <a key={l} href="#" className="text-xs transition-colors" style={linkStyle}
                onMouseEnter={hoverTeal} onMouseLeave={hoverReset}>{l}</a>
            ))}
          </nav>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-xs font-heading font-semibold text-white mb-3">Contact</h4>
          <div className="space-y-2">
            <a href="mailto:hello@carecontext.in" className="flex items-center gap-2 text-xs transition-colors"
              style={linkStyle} onMouseEnter={hoverTeal} onMouseLeave={hoverReset}>
              <i className="fa-solid fa-envelope w-3.5 text-center" />hello@carecontext.in
            </a>
            <p className="flex items-center gap-2 text-xs" style={linkStyle}>
              <i className="fa-solid fa-phone w-3.5 text-center" />+91 XXXX XXXX
            </p>
            <p className="flex items-center gap-2 text-xs" style={linkStyle}>
              <i className="fa-solid fa-location-dot w-3.5 text-center" />Tiruvallur, India
            </p>
          </div>
        </div>
      </div>

      <div className="border-t pt-5" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[11px]" style={{ color: 'rgba(255,255,255,0.4)' }}>&copy; 2026 CareContext Systems. All rights reserved.</p>
          <div className="flex gap-4">
            {["Privacy", "Terms", "Cookies"].map(l => (
              <a key={l} href="#" className="text-[11px] transition-colors" style={{ color: 'rgba(255,255,255,0.4)' }}
                onMouseEnter={hoverTeal} onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.4)'}>{l}</a>
            ))}
          </div>
        </div>
      </div>
    </div>
  </footer>
);
